import React from 'react'
import PropTypes from 'prop-types'
import theme from '../../theme'
import { Box } from '@mui/material'

// material components

const styles = {
    root: {
        display: 'flex',
        flexWrap: "wrap",
        //flexDirection: 'row',
        justifyContent:"space-between",
        height: "auto",
        width:"100%",
        [theme.breakpoints.down('sm')]: {
            width: 'auto',
            height: 'auto',
            flexWrap: 'wrap',
            paddingBottom: 10,
        },
    },
}

/**
 * component wrapper for sidebar
 * @param classes
 * @param children
 * @returns {*}
 * @constructor
 */
const Mode = ({ classes, children, style }) => (
    <Box style={{...styles.root, style}} >
        {children}
    </Box>
)

Mode.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    children: PropTypes.node.isRequired,
    style: PropTypes.object
}

export default Mode
